export default "__VITE_ASSET__wvehfnbd__"